(() => {
  const P = 'JRMVariantGalleryData-';
  const K = '__JRMGalleryControlsV6';
  const LEGACY_KEYS = [
    '__JRMGalleryControlsV2',
    '__JRMGalleryControlsV3',
    '__JRMGalleryControlsV4',
    '__JRMGalleryControlsV5',
    K
  ];
  const INITIAL_COMMON = 4;
  const MORE = 'View more product photos';
  const LESS = 'Show fewer product photos';
  const HOST_CLASS = 'jrm-gallery-controls-host';
  const STYLE_ID = 'jrm-gallery-controls-style';

  const mid = value => String(value ?? '').split('/').pop();
  const path = value => {
    if (!value) return '';
    try { return new URL(value, location.origin).pathname; }
    catch { return String(value).split('?')[0]; }
  };
  const urlVariant = () => {
    try { return new URL(location.href).searchParams.get('variant'); }
    catch { return null; }
  };

  function abortInlineGalleryControllers() {
    const controllers = window.JRMVariantGalleryControllers;
    if (!controllers || typeof controllers !== 'object') return;

    Object.values(controllers).forEach(controller => controller?.abort?.());
    window.JRMVariantGalleryControllers = {};
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      hdt-product-media.${HOST_CLASS} {
        padding-bottom: 4.6rem;
      }
      hdt-product-media.${HOST_CLASS} > .jrm-gallery-view-controls {
        position: absolute;
        inset-inline: 0;
        bottom: 0;
        min-height: 3.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        z-index: 20;
        pointer-events: auto;
      }
      hdt-product-media.${HOST_CLASS} > .jrm-gallery-view-controls[hidden] {
        display: none !important;
      }
      .jrm-gallery-view-controls__button {
        position: relative;
        z-index: 1;
        pointer-events: auto;
      }
      @media (max-width: 767px) {
        hdt-product-media.${HOST_CLASS} {
          position: relative;
        }
      }
    `;
    document.head.append(style);
  }

  function make(dataRoot) {
    let data;
    try { data = JSON.parse(dataRoot.textContent || '{}'); }
    catch { return null; }

    const section = dataRoot.closest('.shopify-section') || document;
    const media = section.querySelector('hdt-product-media');
    if (!media) return null;

    ensureStyle();

    const mains = () => [...media.querySelectorAll('.hdt-product-media__main [data-media-id]')];
    const thumbs = () => [...media.querySelectorAll('hdt-slider-thumb [data-media-id]')];
    const reinit = () => {
      media.sliderMain?.reInit?.();
      media.sliderThumb?.reInit?.();
    };
    const goto = item => item && requestAnimationFrame(() => media.sliderMain?.goToTarget?.(item));
    const current = () => {
      const visible = mains().filter(item => !item.hidden);
      return visible.find(item =>
        item.matches('[aria-current="true"],[selected]') ||
        item.classList.contains('is-selected') ||
        item.classList.contains('hdt-slider__slide--selected')
      ) || visible[0] || null;
    };

    const originalMainOrder = mains().map(item => mid(item.dataset.mediaId)).filter(Boolean);

    function mediaLookup() {
      const byId = new Map();
      const byPath = new Map();
      mains().forEach(item => {
        const id = mid(item.dataset.mediaId);
        if (id) byId.set(id, id);
        const img = item.querySelector('img');
        [img?.currentSrc, img?.src, img?.getAttribute('src')].forEach(src => {
          const p = path(src);
          if (p && id) byPath.set(p, id);
        });
      });
      return { byId, byPath };
    }

    function variantIds(variantId) {
      const entries = data[String(variantId)] || [];
      if (!Array.isArray(entries) || !entries.length) return [];
      const { byId, byPath } = mediaLookup();
      const out = [];

      entries.forEach(entry => {
        const entryId = mid(entry?.id);
        const id = (entryId && byId.get(entryId)) || byPath.get(path(entry?.src)) || '';
        if (id && !out.includes(id)) out.push(id);
      });

      return out;
    }

    function hasCompleteVariantCoverage() {
      const galleries = Object.values(data);
      return galleries.length > 0 && galleries.every(gallery => Array.isArray(gallery) && gallery.length > 0);
    }

    function commonIds() {
      const canonical = mains()
        .filter(item => item.dataset.jrmCommon === 'true')
        .map(item => mid(item.dataset.mediaId))
        .filter(Boolean);

      if (canonical.length) return canonical;
      if (!hasCompleteVariantCoverage()) return [];

      const usedByVariants = new Set();
      Object.keys(data).forEach(variantId => {
        variantIds(variantId).forEach(id => usedByVariants.add(id));
      });
      return originalMainOrder.filter(id => id && !usedByVariants.has(id));
    }

    function materializeItem(item, { priority = false } = {}) {
      if (!item || item.dataset.jrmDeferred !== 'true') return;

      const template = item.querySelector(
        'template[data-jrm-media-template], template[data-jrm-thumb-template]'
      );

      if (!template) {
        item.removeAttribute('data-jrm-deferred');
        return;
      }

      const fragment = template.content.cloneNode(true);
      if (priority) {
        const img = fragment.querySelector?.('img');
        if (img) {
          img.setAttribute('loading', 'eager');
          img.setAttribute('fetchpriority', 'high');
          try { img.fetchPriority = 'high'; } catch {}
        }
      }

      template.replaceWith(fragment);
      item.removeAttribute('data-jrm-deferred');
    }

    function materializeIds(ids, { priorityFirst = false } = {}) {
      const mainMap = new Map(mains().map(item => [mid(item.dataset.mediaId), item]));
      const thumbMap = new Map(thumbs().map(item => [mid(item.dataset.mediaId), item]));

      ids.forEach((id, index) => {
        materializeItem(mainMap.get(id), { priority: priorityFirst && index === 0 });
        materializeItem(thumbMap.get(id));
      });
    }

    function materializeAll() {
      mains().forEach(item => materializeItem(item));
      thumbs().forEach(item => materializeItem(item));
    }

    function setControlVisible(visible) {
      wrap.hidden = !visible;
      media.classList.toggle(HOST_CLASS, visible);
    }

    function showNative() {
      materializeAll();
      const keep = current();
      mains().forEach(item => { item.hidden = false; });
      thumbs().forEach(item => { item.hidden = false; });
      setControlVisible(false);
      reinit();
      goto(keep);
    }

    const wrap = document.createElement('div');
    wrap.className = 'jrm-gallery-view-controls';
    wrap.hidden = true;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jrm-gallery-view-controls__button';
    btn.textContent = MORE;
    wrap.append(btn);
    media.append(wrap);

    const state = {
      variantId: urlVariant(),
      expandedCommon: false
    };

    function render({ jumpToVariant = false } = {}) {
      const common = commonIds();

      if (!common.length || !hasCompleteVariantCoverage()) {
        showNative();
        return;
      }

      let selected = [];
      if (state.variantId) {
        selected = variantIds(state.variantId);
        if (!selected.length) {
          showNative();
          return;
        }
      }

      const visibleCommon = state.expandedCommon
        ? common
        : common.slice(0, INITIAL_COMMON);
      const wanted = [...selected, ...visibleCommon];

      // Materialize only what the shopper asked to see. Hidden variant images
      // remain inert <template> content and therefore do not start image requests.
      materializeIds(wanted, { priorityFirst: selected.length > 0 });

      const allowed = new Set(wanted);
      const keep = current();

      mains().forEach(item => {
        item.hidden = !allowed.has(mid(item.dataset.mediaId));
      });
      thumbs().forEach(item => {
        item.hidden = !allowed.has(mid(item.dataset.mediaId));
      });
      reinit();

      let target = null;
      if (jumpToVariant && selected.length) {
        target = mains().find(item => mid(item.dataset.mediaId) === selected[0]);
      } else if (keep && !keep.hidden) {
        target = keep;
      } else if (selected.length) {
        target = mains().find(item => mid(item.dataset.mediaId) === selected[0]);
      } else if (visibleCommon.length) {
        target = mains().find(item => mid(item.dataset.mediaId) === visibleCommon[0]);
      }
      goto(target);

      setControlVisible(common.length > INITIAL_COMMON);
      btn.textContent = state.expandedCommon ? LESS : MORE;
    }

    btn.addEventListener('click', () => {
      state.expandedCommon = !state.expandedCommon;
      render();
    });

    const onVariant = event => {
      const variant = event.detail?.variant;
      if (!variant?.id || !Object.prototype.hasOwnProperty.call(data, String(variant.id))) return;
      state.variantId = String(variant.id);
      requestAnimationFrame(() => render({ jumpToVariant: true }));
    };

    let resizeTimer = 0;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => render(), 120);
    };

    document.addEventListener('variant:change', onVariant);
    window.addEventListener('resize', onResize, { passive: true });
    requestAnimationFrame(() => render({ jumpToVariant: Boolean(state.variantId) }));

    return {
      destroy() {
        document.removeEventListener('variant:change', onVariant);
        window.removeEventListener('resize', onResize);
        window.clearTimeout(resizeTimer);
        media.classList.remove(HOST_CLASS);
        wrap.remove();
      }
    };
  }

  function init() {
    abortInlineGalleryControllers();

    LEGACY_KEYS.forEach(key => {
      window[key]?.forEach?.(controller => controller.destroy());
      if (key !== K) delete window[key];
    });

    window[K] = [...document.querySelectorAll(`script[id^="${P}"]`)]
      .map(make)
      .filter(Boolean);

    // The original inline gallery controller can finish its custom-element
    // promise slightly later. Abort it once more after our controller owns the gallery.
    window.setTimeout(abortInlineGalleryControllers, 0);
    window.setTimeout(abortInlineGalleryControllers, 250);
  }

  function start() {
    const ready = window.customElements?.whenDefined
      ? customElements.whenDefined('hdt-product-media')
      : Promise.resolve();

    ready.then(() => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }
    });
  }

  start();
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(init));
})();
